var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgNursingHomeContracts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 93,
    viewBox: "0 0 94 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 16H83V87H11V16Z",
    fill: "#B0D2EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 37C21 36.4477 21.4477 36 22 36H72C72.5523 36 73 36.4477 73 37V38C73 38.5523 72.5523 39 72 39H22C21.4477 39 21 38.5523 21 38V37Z",
    fill: "#D6E8F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 44C21 43.4477 21.4477 43 22 43H72C72.5523 43 73 43.4477 73 44V45C73 45.5523 72.5523 46 72 46H22C21.4477 46 21 45.5523 21 45V44Z",
    fill: "#D6E8F6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 51C21 50.4477 21.4477 50 22 50H72C72.5523 50 73 50.4477 73 51V52C73 52.5523 72.5523 53 72 53H22C21.4477 53 21 52.5523 21 52V51Z",
    fill: "#D6E8F6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0212 91.0667H32.9805V69.0046C32.9805 66.6107 34.9213 64.6699 37.3151 64.6699H56.6866C59.0804 64.6699 61.0205 66.6107 61.0205 69.0046V91.0667H61.0212Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4082 64.6699H48.5922V91.0667H45.4082V64.6699Z",
    fill: "#4D86B5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 89C0 87.8954 0.897818 87 2.00533 87H91.9947C93.1022 87 94 87.8954 94 89V90.93C94 92.0346 93.1022 92.93 91.9947 92.93H2.00533C0.897819 92.93 0 92.0346 0 90.93V89Z",
    fill: "#031C2E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5 14C5 12.8954 5.8981 12 7.00597 12H86.994C88.1019 12 89 12.8954 89 14V15.93C89 17.0346 88.1019 17.93 86.994 17.93H7.00597C5.8981 17.93 5 17.0346 5 15.93V14Z",
    fill: "#4B81AC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M62 15C62 23.2843 55.2843 30 47 30C38.7157 30 32 23.2843 32 15C32 6.71573 38.7157 0 47 0C55.2843 0 62 6.71573 62 15Z",
    fill: "#3A8761"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0328 13.0328H48.9672V8.96718C48.9672 7.88016 48.087 7 47 7C45.913 7 45.0328 7.88016 45.0328 8.96718V13.0328H40.9672C39.8812 13.0328 39 13.913 39 15C39 16.086 39.8812 16.9672 40.9672 16.9672H45.0328V21.0318C45.0328 22.1188 45.913 23 47 23C48.087 23 48.9672 22.1188 48.9672 21.0318V16.9662H53.0328C54.1188 16.9662 55 16.086 55 14.999C55 13.913 54.1188 13.0328 53.0328 13.0328Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgNursingHomeContracts);
export default __webpack_public_path__ + "static/media/imgNursingHomeContracts.009b4c5d8ac5c01e721e6d7ceffe2f7f.svg";
export { ForwardRef as ReactComponent };